export function parseSiteSlotArray (raw, keepEmpty = true) {
  if (Array.isArray(raw)) {
    const arr = raw.map(item => String(item == null ? '' : item).trim())
    return keepEmpty ? arr : arr.filter(item => item !== '')
  }

  const text = String(raw == null ? '' : raw).trim()
  if (text === '' || text === 'null') return []

  try {
    const decoded = JSON.parse(text)
    if (Array.isArray(decoded)) {
      const arr = decoded.map(item => String(item == null ? '' : item).trim())
      return keepEmpty ? arr : arr.filter(item => item !== '')
    }
  } catch (error) {}

  const arr = text.replace(/，/g, ',').split(',').map(item => item.trim())
  return keepEmpty ? arr : arr.filter(item => item !== '')
}

export function hasRunningPlane (raw) {
  return parseSiteSlotArray(raw, true).some(item => item !== '')
}

export function normalizeSiteRuntime (site) {
  const bindRouteArray = parseSiteSlotArray(site && site.bind_route, false)
  const runingArray = parseSiteSlotArray(site && site.runing, true)

  while (runingArray.length < bindRouteArray.length) {
    runingArray.push('')
  }

  if (runingArray.length > bindRouteArray.length) {
    runingArray.length = bindRouteArray.length
  }

  return {
    bindRouteArray,
    runingArray
  }
}

export function getBoundSiteRoutes (routes, sites, shopId = '') {
  const bindings = new Map()
  sites.forEach(site => {
    const siteShopId = String(site.shop_id || '')
    if (shopId && siteShopId !== String(shopId)) return
    normalizeSiteRuntime(site).bindRouteArray.forEach(id => {
      if (!bindings.has(id)) bindings.set(id, new Set())
      bindings.get(id).add(siteShopId)
    })
  })
  return routes.filter(route => {
    const routeShopId = String(route.shop_id || '')
    return (!shopId || routeShopId === String(shopId)) && Boolean(bindings.get(String(route.id))?.has(routeShopId))
  })
}
